import {
	TOGGLE_SIDEBAR
} from './actionTypes';

export const toggleSidebar = () => ({
	type: TOGGLE_SIDEBAR
});
